// ATTICUS-ANALYTICS-COMMAND-CENTER-1 — scoped stylesheet for the Analytics
// surface. Injected once via a <style> tag in Analytics.js so the feature is
// self-contained. Uses the global CSS color tokens (--navy/--blue/etc.).
export const ANALYTICS_CSS = `
/* fill the keep-alive flex wrapper and own the scroll (like .page) */
.an-page { flex: 1 1 auto; min-height: 0; overflow-y: auto; padding: 16px 16px 48px; color: var(--text); }
.an-error { padding: 24px; color: var(--red); }

/* header + lens tabs */
.an-header { display:flex; align-items:flex-end; justify-content:space-between; gap:16px; flex-wrap:wrap; margin-bottom:14px; }
.an-h-title { font-size:22px; font-weight:700; color:var(--navy); letter-spacing:-0.01em; }
.an-h-sub { font-size:12.5px; color:var(--text2); margin-top:2px; }
.an-lenstabs { display:flex; gap:4px; background:var(--bg3); padding:4px; border-radius:10px; flex-wrap:wrap; }
.an-lenstab { display:flex; align-items:center; gap:6px; border:none; background:transparent; color:var(--text2);
  font-size:12.5px; font-weight:600; padding:7px 13px; border-radius:7px; cursor:pointer; transition:all .12s; }
.an-lenstab:hover { color:var(--navy); background:rgba(255,255,255,.6); }
.an-lenstab.active { background:#fff; color:var(--blue); box-shadow:0 1px 3px rgba(26,39,68,.12); }
.an-lenstab-ic { font-size:12px; opacity:.85; }

/* filters */
.an-filters { display:flex; align-items:center; gap:10px; flex-wrap:wrap; background:#fff; border:1px solid var(--border);
  border-radius:10px; padding:10px 12px; margin-bottom:16px; }
.an-filter-group { display:flex; gap:3px; background:var(--bg3); padding:3px; border-radius:8px; }
.an-chip { border:none; background:transparent; font-size:11.5px; font-weight:600; color:var(--text2);
  padding:5px 10px; border-radius:6px; cursor:pointer; }
.an-chip.active { background:#fff; color:var(--blue); box-shadow:0 1px 2px rgba(26,39,68,.1); }
.an-sel { display:flex; flex-direction:column; gap:2px; font-size:10px; color:var(--text3); text-transform:uppercase; letter-spacing:.03em; }
.an-sel select { font-size:12.5px; color:var(--text); border:1px solid var(--border); border-radius:7px; padding:5px 8px;
  background:#fff; min-width:96px; text-transform:none; letter-spacing:0; }
.an-reset { margin-left:2px; border:1px solid var(--border); background:#fff; color:var(--text2); font-size:12px;
  font-weight:600; padding:7px 12px; border-radius:7px; cursor:pointer; align-self:flex-end; }
.an-reset:hover { color:var(--red); border-color:var(--red); }
.an-refreshed { margin-left:auto; display:flex; align-items:center; gap:8px; font-size:11px; color:var(--text3); align-self:flex-end; }
.an-refresh-btn { border:1px solid var(--border); background:#fff; border-radius:7px; padding:5px 9px; cursor:pointer; font-size:13px; color:var(--blue); }

/* KPI band */
.an-stack { display:flex; flex-direction:column; gap:16px; }
.an-kpis { display:grid; grid-template-columns:repeat(5, 1fr); gap:12px; }
.an-kpi { position:relative; background:#fff; border:1px solid var(--border); border-left:3px solid var(--blue);
  border-radius:10px; padding:13px 15px; overflow:hidden; }
.an-kpi.clickable { cursor:pointer; transition:transform .1s, box-shadow .1s; }
.an-kpi.clickable:hover { transform:translateY(-2px); box-shadow:0 6px 18px rgba(26,39,68,.12); }
.an-kpi.navy { border-left-color:var(--navy); } .an-kpi.green { border-left-color:var(--green); }
.an-kpi.amber { border-left-color:var(--yellow); } .an-kpi.red { border-left-color:var(--red); }
.an-kpi.blue { border-left-color:var(--blue); }
.an-kpi-label { font-size:10.5px; font-weight:600; text-transform:uppercase; letter-spacing:.04em; color:var(--text3); }
.an-kpi-value { font-size:23px; font-weight:700; color:var(--navy); margin-top:5px; font-variant-numeric:tabular-nums; line-height:1.1; }
.an-kpi-sub { font-size:11px; color:var(--text2); margin-top:3px; }
.an-spark { position:absolute; right:10px; bottom:8px; opacity:.5; }

/* chart card grid */
.an-grid { display:grid; grid-template-columns:repeat(12, 1fr); gap:16px; }
.an-card { grid-column:span 6; background:#fff; border:1px solid var(--border); border-radius:12px;
  display:flex; flex-direction:column; box-shadow:0 1px 3px rgba(26,39,68,.05); }
.an-card.wide { grid-column:span 12; }
.an-card-head { display:flex; align-items:flex-start; justify-content:space-between; gap:10px; padding:13px 16px 6px; }
.an-card-title { font-size:13.5px; font-weight:700; color:var(--navy); }
.an-card-sub { font-size:11px; color:var(--text3); margin-top:1px; }
.an-card-controls { display:flex; gap:6px; }
.an-card-body { padding:6px 12px 12px; flex:1; min-height:120px; display:flex; flex-direction:column; justify-content:center; }
.an-card-foot { padding:8px 16px; border-top:1px solid var(--bg3); }

/* tooltip */
.an-tt { background:var(--navy); color:#fff; border-radius:8px; padding:8px 10px; font-size:11.5px; box-shadow:0 4px 14px rgba(0,0,0,.25); }
.an-tt-label { font-weight:700; margin-bottom:4px; opacity:.9; }
.an-tt-row { display:flex; align-items:center; gap:6px; }
.an-tt-dot { width:8px; height:8px; border-radius:2px; display:inline-block; }
.an-tt-name { opacity:.85; } .an-tt-val { margin-left:auto; font-weight:700; font-variant-numeric:tabular-nums; }

/* tables */
.an-exposure-table, .an-drill-table { width:100%; border-collapse:collapse; font-size:12.5px; }
.an-exposure-table th, .an-drill-table th { text-align:left; font-size:10.5px; text-transform:uppercase; letter-spacing:.03em;
  color:var(--text3); font-weight:600; padding:6px 8px; border-bottom:1px solid var(--border); }
.an-exposure-table td, .an-drill-table td { padding:7px 8px; border-bottom:1px solid var(--bg3); }
.an-exposure-table .r, .an-drill-table .r, th.r, td.r { text-align:right; }
.an-exposure-table tr:hover td, .an-drill-table tr:hover td { background:var(--bg); }
.an-link { background:none; border:none; color:var(--blue); font-weight:600; font-size:12px; cursor:pointer; padding:0; }
.an-link:hover { text-decoration:underline; }

/* unavailable / coming soon */
.an-unavailable { display:flex; flex-direction:column; align-items:center; gap:7px; text-align:center; padding:22px 16px; color:var(--text2); }
.an-unavailable-icon { font-size:24px; opacity:.55; }
.an-unavailable-reason { font-size:12px; max-width:280px; }
.an-unavailable-dep { font-size:11px; color:var(--text3); font-style:italic; }
.an-comingsoon { display:flex; flex-direction:column; align-items:center; justify-content:center; gap:8px; text-align:center;
  padding:60px 20px; background:#fff; border:1px dashed var(--border); border-radius:12px; color:var(--text2); }
.an-comingsoon-icon { font-size:32px; opacity:.5; }
.an-comingsoon-title { font-size:16px; font-weight:700; color:var(--navy); }
.an-comingsoon-sub { font-size:12.5px; max-width:420px; line-height:1.55; }
.an-personal { background:#fff; border:1px solid var(--border); border-radius:12px; padding:8px 12px; }

/* bullet */
.an-bullet { display:flex; align-items:center; gap:8px; }
.an-bullet-track { position:relative; flex:1; height:10px; background:var(--bg3); border-radius:5px; }
.an-bullet-fill { position:absolute; left:0; top:0; bottom:0; border-radius:5px; }
.an-bullet-target { position:absolute; top:-3px; bottom:-3px; width:2px; background:var(--navy); }
.an-bullet-label { font-size:11px; color:var(--text2); min-width:42px; }

/* drilldown drawer */
.an-drawer-overlay { position:fixed; inset:0; background:rgba(26,39,68,.32); z-index:1200; display:flex; justify-content:flex-end; }
.an-drawer { width:min(720px, 94vw); background:#fff; height:100%; display:flex; flex-direction:column;
  box-shadow:-8px 0 30px rgba(0,0,0,.18); animation:an-slidein .18s ease; }
@keyframes an-slidein { from { transform:translateX(30px); opacity:.4; } to { transform:none; opacity:1; } }
.an-drawer-head { display:flex; align-items:flex-start; justify-content:space-between; padding:16px 18px 12px; border-bottom:1px solid var(--border); }
.an-drawer-title { font-size:16px; font-weight:700; color:var(--navy); }
.an-drawer-meta { font-size:11.5px; color:var(--text2); margin-top:2px; }
.an-drawer-actions { display:flex; gap:6px; }
.an-btn { border:1px solid var(--border); background:#fff; color:var(--text2); font-size:12px; font-weight:600;
  padding:6px 11px; border-radius:7px; cursor:pointer; }
.an-btn:hover { border-color:var(--blue); color:var(--blue); }
.an-btn-close { font-size:18px; line-height:1; padding:3px 10px; }
.an-context { display:flex; gap:6px; flex-wrap:wrap; padding:10px 18px; border-bottom:1px solid var(--bg3); }
.an-context-chip { font-size:11px; background:var(--bg3); color:var(--text2); padding:3px 9px; border-radius:12px; }
.an-drawer-body { flex:1; overflow:auto; padding:8px 18px 24px; }

@media (max-width:1100px) { .an-kpis { grid-template-columns:repeat(3,1fr); } .an-card { grid-column:span 12; } }
/* My Numbers — WIP detail list */
.mn-wip { display:flex; flex-direction:column; }
.mn-wip-head { background:var(--navy); color:#fff; padding:7px 14px; display:flex; justify-content:space-between; font-weight:600; font-size:12.5px; }
.mn-wip-row { padding:7px 14px 7px 26px; border-bottom:1px solid var(--bg3); display:flex; align-items:center; gap:14px; font-size:12px; }
.mn-wip-group { margin-bottom:8px; }

@media (max-width:680px) { .an-kpis { grid-template-columns:repeat(2,1fr); } }
`;
